import ArkAiAnimation from '@/assets/ark-ai.gif';
import ArkAiIcon from '@/assets/ark-ai.svg';
import ArkUpdatePlaceholder from '@/assets/arkActive.png';
import ArkFavicon from '@/assets/favicon.ico';
import ArkFaviconNotification from '@/assets/favicon-notifcation.ico';
import ArkLogo from '@/assets/brickLogo.png';
import ArkLogoChristmas from '@/assets/brickLogoChristmas.png';
import ArkSymbol from '@/assets/logos/ark_symbol_black.svg';
import ArkWhiteLogo from '@/assets/logos/whiteLogo.svg';
import ArkTiledBackground from '@/assets/tiledBackground.svg';
import CortileAiAnimation from '@/assets/cortile/ai-animated.svg';
import CortileFavicon from '@/assets/cortile/favicon.ico';
import CortileFaviconNotification from '@/assets/cortile/favicon-notification.ico';
import CortileLockup from '@/assets/cortile/lockup-terracotta-slate.svg';
import CortileLockupWhite from '@/assets/cortile/lockup-white.svg';
import CortileSymbol from '@/assets/cortile/symbol-terracotta.svg';
import CortileSymbolWhite from '@/assets/cortile/symbol-white.svg';
import CortileTiledBackground from '@/assets/cortile/tiledBackground.svg';
import {BrandKey} from '@ark/react';

export type BrandAssets = {
  favicon: string;
  faviconNotification: string;
  symbol: string;
  logo: string;
  mark: string;
  logoChristmas: string;
  logoDark: string;
  aiIcon: string;
  aiAnimation: string;
  manifest: string;
  touchIcon: string;
  tiledBackground: string;
  updatePlaceholder: string;
  description: string;
  themeColor: string;
};

export const brandAssets: Record<BrandKey, BrandAssets> = {
  ark: {
    favicon: ArkFavicon,
    faviconNotification: ArkFaviconNotification,
    symbol: ArkSymbol,
    logo: ArkLogo,
    mark: ArkLogo,
    logoChristmas: ArkLogoChristmas,
    logoDark: ArkWhiteLogo,
    aiIcon: ArkAiIcon,
    aiAnimation: ArkAiAnimation,
    manifest: '/manifest.json',
    touchIcon: '/logo192.png',
    tiledBackground: ArkTiledBackground,
    updatePlaceholder: ArkUpdatePlaceholder,
    description:
      "Know your rental homes are compliant. No more sleepless nights, and it's free!",
    themeColor: '#000000',
  },
  cortile: {
    favicon: CortileFavicon,
    faviconNotification: CortileFaviconNotification,
    symbol: CortileSymbol,
    logo: CortileLockup,
    mark: CortileSymbol,
    logoChristmas: CortileLockup,
    logoDark: CortileLockupWhite,
    aiIcon: CortileSymbol,
    aiAnimation: CortileAiAnimation,
    manifest: '/manifest-cortile.json',
    touchIcon: '/cortile-192.png',
    tiledBackground: CortileTiledBackground,
    updatePlaceholder: CortileSymbolWhite,
    description:
      'Cortile helps property managers run their buildings and look after residents, all in one place.',
    themeColor: '#1F2320',
  },
};
